<template>
  <div class="banner h4">
    {{ title }}
  </div>
</template>

<script>
export default {
  name: "AppBanner",

  props: ["title"]
};
</script>

<style scoped>
.banner {
  width: 100%;
  height: 30px;
  background-color: var(--dk-gray);
  color: var(--white);
  padding: 5px 32px;
  display: flex;
  align-items: center;
}

@media (min-width: 768px) {
  .banner {
    padding: 5px 5%;
  }
}
</style>
